
export const GET_LIST_DISCOUNT = 'GET_LIST_DISCOUNT'
export const GET_LIST_DISCOUNT_SUCCESS = 'GET_LIST_DISCOUNT_SUCCESS'
export const GET_LIST_DISCOUNT_FAIL = 'GET_LIST_DISCOUNT_FAIL'

export const CREATE_NEW_DISCOUNT = 'CREATE_NEW_DISCOUNT'
export const CREATE_NEW_DISCOUNT_SUCCESS = 'CREATE_NEW_DISCOUNT_SUCCESS'
export const CREATE_NEW_DISCOUNT_FAIL = 'CREATE_NEW_DISCOUNT_FAIL'
